const U = "https://images.unsplash.com/";
export const DEFAULT_IMAGES = {
  hero: U + "photo-1670058124043-4f55e08d0f8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  buffet: U + "photo-1593755768134-fa73738bcb77?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  spread: U + "photo-1682862279256-b2a9e4f3d22c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  hands: U + "photo-1728910156510-77488f19b152?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  biryani: U + "photo-1589302168068-964664d93dc0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  biryani2: U + "photo-1716550781939-beb7d7247aae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  prawns: U + "photo-1594489237444-e68a0ad88c9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  seafood: U + "photo-1596797038530-2c107229654b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  mutton: U + "photo-1710091691771-96b2e6d17dac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  mutton2: U + "photo-1606843046080-45bf7a23c39f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  sweets: U + "photo-1758910536889-43ce7b3199fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  gulab: "https://images.pexels.com/photos/11887844/pexels-photo-11887844.jpeg?auto=compress&cs=tinysrgb&w=1400",
  wedding: U + "photo-1511795409834-ef04bbd61622?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  wedding2: U + "photo-1562050344-f7ad946cee35?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  toast: U + "photo-1527529482837-4698179dc6ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  corporate: U + "photo-1576842546422-60562b9242ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  corp_boxes: U + "photo-1672826979217-7156a305acf5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  chef: U + "photo-1581349485608-9469926a8e5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  chef2: U + "photo-1577219492769-b63a779fac28?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  flame: U + "photo-1600565193348-f74bd3c7ccdf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  flame2: U + "photo-1670819916552-67698b1c86ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  tandoori: "https://static.prod-images.emergentagent.com/jobs/cb7a0043-2ce2-4526-b092-9bd10a668f0f/images/4d24ec97a66ce1912e37a7cb7e77b8425f172ff16e9f7803a65917db497108fc.jpeg",
  grill_v: "https://static.prod-images.emergentagent.com/jobs/cb7a0043-2ce2-4526-b092-9bd10a668f0f/images/13ec86d85dc49fc1192e15cb2263edee366c290a59c6b552a297b823fd34c98b.jpeg",
};

export const DEFAULT_SETTINGS = {
  brand_name: "FOODIE CONNECT CATERER",
  tagline: "OFFERING FLAVOURS",
  logo_url: "/logo.jpeg",
  phone: "+91 93812 05545",
  whatsapp: "919381205545",
  whatsapp_message: "Hello Foodie Connect Caterer, I would like to enquire about catering for my event.",
  email: "hello@foodieconnectcaterer.com",
  address: "Hyderabad, Telangana, India",
  hero_headline: "WHERE GREAT FOOD MEETS GREAT OCCASIONS.",
  hero_sub: "Premium catering crafted for celebrations, businesses and every occasion worth gathering for.",
  hero_image: DEFAULT_IMAGES.hero,
  flavour_mode: "MENU",
  show_3d: true,
  socials: { instagram: "#", facebook: "#", youtube: "#" },
  images: DEFAULT_IMAGES,
};
